/**
 * Recent case references — persisted in localStorage so the command palette
 * can offer the last opened cases (point 14c). Max 8, most-recent-first.
 */
import { useEffect } from 'react';

const KEY = 'sai.console.recentCases';
const MAX_RECENT = 8;

export interface RecentCase {
  reference: string;
  at: number;
}

export function readRecentCases(): RecentCase[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (entry): entry is RecentCase =>
          typeof entry === 'object' &&
          entry !== null &&
          typeof (entry as RecentCase).reference === 'string' &&
          typeof (entry as RecentCase).at === 'number',
      )
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
}

export function recordRecentCase(reference: string): void {
  if (!reference) return;
  try {
    const next = [
      { reference, at: Date.now() },
      ...readRecentCases().filter((entry) => entry.reference !== reference),
    ].slice(0, MAX_RECENT);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable */
  }
}

/** Remember the opened case for the command palette's recent-cases group. */
export function useRecordRecentCase(reference: string): void {
  useEffect(() => {
    recordRecentCase(reference);
  }, [reference]);
}
